import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TransactionSigningService } from './transaction-signing.service';

/**
 * Interceptor used to check for reauthentication errors
 */
@Injectable()
export class TransactionSigningInterceptor implements HttpInterceptor {
  constructor(private readonly transactionSigningService: TransactionSigningService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error) => {
        return this.transactionSigningService.initiateTransactionSigning(error);
      }),
    );
  }
}
